/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_CreateInputs */

const en_common_create = /** @type {(inputs: Common_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create`)
};

const de_common_create = /** @type {(inputs: Common_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstellen`)
};

const fr_common_create = /** @type {(inputs: Common_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créer`)
};

const es_common_create = /** @type {(inputs: Common_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear`)
};

const it_common_create = /** @type {(inputs: Common_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea`)
};

const nl_common_create = /** @type {(inputs: Common_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aanmaken`)
};

const pl_common_create = /** @type {(inputs: Common_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utwórz`)
};

const fi_common_create = /** @type {(inputs: Common_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luo`)
};

const da_common_create = /** @type {(inputs: Common_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opret`)
};

const sv_common_create = /** @type {(inputs: Common_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skapa`)
};

/**
* | output |
* | --- |
* | "Create" |
*
* @param {Common_CreateInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const common_create = /** @type {((inputs?: Common_CreateInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_CreateInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_common_create(inputs)
	if (locale === "fr") return fr_common_create(inputs)
	if (locale === "es") return es_common_create(inputs)
	if (locale === "it") return it_common_create(inputs)
	if (locale === "nl") return nl_common_create(inputs)
	if (locale === "pl") return pl_common_create(inputs)
	if (locale === "fi") return fi_common_create(inputs)
	if (locale === "da") return da_common_create(inputs)
	if (locale === "sv") return sv_common_create(inputs)
	return en_common_create(inputs)
});